<div class="message-wrapper">
  <i class="icon-CheckCircle"></i>
  <div class="flex flex-column text-wrapper">
    @if (title && title.length) {
      <span class="text--bold">{{ title }}</span>
    }
    <span class="text">{{ message }}</span>
  </div>
  <i class="icon-X" matSnackBarActions (click)="snackBarRef.dismissWithAction()"></i>
</div>
